import React from "react";
import { Select } from "components/common";
import Table from "components/table";

export default class ShareEditor extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
			sharedData: [],
            cancelLoad: false,
			isAddButtonDisable: true,
            courseaction: {},
            user: {},
			can_delete: false,
            usersUrl: "/courseactions/envolvedUsers.json",
			url: "/filesmanager/getSharedOptions.json",
			target_alias: []
        };

		this.data = [],
		this.columnFilters = {
			status: {
				render: () => {
					const empty = !this.data || this.data.length == 0

					return (
						<div className="btn-group btn-group-xs">
							<button className="btn btn-default btn-circular" value="1" disabled={empty} onClick={this.onCheckAll}>
								<em className="la la-times" />
							</button>
						</div>
					)
				}
			}
		}
    }

    onCourseActionChanged = (courseaction) => {
		let isAddButtonDisable = false;
		if(!courseaction.id && !this.state.user.id) {
			isAddButtonDisable = true;
		}
		const usersUrl = `/courseactions/envolvedUsers.json?action_id=`+courseaction.id;
		this.setState({ courseaction, isAddButtonDisable, usersUrl});
    };

    onUsersChanged = (user) => {
		let isAddButtonDisable = false;
		if(!user.id && !this.state.courseaction.id) {
			isAddButtonDisable = true;
		}
		this.setState({user, isAddButtonDisable});
    };

	saveShareOption = () => {
		const { sharedData } = this.state;
		const shareOption = {
			courseaction: this.state.courseaction,
			user_group:  this.state.user
		}
		
		http.post('/filesmanager/shareFile.json', { targets: this.state.target_alias, shareOption  }, async (response) => {
			let { url } = this.state
			this.setState({ 
				url: `${url}&time=${Date.now()}`, 
				sharedData, 
				courseaction: null,
				user: null,
				isAddButtonDisable: true
			});
		})
	}

	deleteSharedOption = () => {
		let dbfile_shared_ids = this.data.filter(item => item.action  == 1).map(item => item.id);
		mbox.confirmDelete(
			() => {
				http.post('/filesmanager/deleteSharedOptions.json', { dbfile_shared_ids  }, async (response) => {
					const { sharedData } = this.state;
					dbfile_shared_ids.forEach((selectedId) => {
						const selected_index = sharedData.findIndex(item => item.id === selectedId);
						sharedData.splice(selected_index, 1);
					});
					this.forceUpdate();
					mbox.dismiss();
				 })
			},
			" partilhas selecionadas"
		)
	}

	onDataFetched = (data) => {
		this.data = data;
		this.setState({ can_delete: false, sharedData: data });
	};

	formatStatus = (_, row) => {
		return (
			<div className="btn-group btn-group-xs">
				<button
					key="reject"
					className={`btn ${row.action == 1 ? "btn-danger" : "btn-default"} btn-circular`}
					onClick={this.onCheck.bind(this, row, 1)}
					title="Eliminar"
				>
					<em className="la la-times" />
				</button>
			</div>
		);
	}

	onCheck(row, op) {
		let can_delete = false;

		row.action = row.action == op ? 0 : op;

		for (let row of this.data) {
			if (row.action > 0) {
				can_delete = true;
				break;
			}
		}
		this.setState({
			can_delete: can_delete,
		});
	}

	onCheckAll = (e) => {
		if (this.data.length == 0) {
			return;
		}
		let op = e.currentTarget.getAttribute("value");

		op = op == this.data[0].action ? 0 : op;
		for (let row of this.data) {
			row.action = op;
		}
		this.setState({
			can_delete: op != 0,
		});
	};

	componentDidMount() {
		let { url } = this.state;
		console.log(this.props.targets);
		const target_alias = this.props.targets.map(file => file.alias);

		url = `${url}?targets=${this.props.targets.map(file => file.path)}`;
		this.setState({url, target_alias})
	}

    render() {
        return (
            <div className="widget-content form-horizontal pt-2 px-1">
                <Select
                    key="ca"
                    name="action"
					value={this.state.courseaction}
                    label={__("courseactions_single")}
                    className="row form-group"
                    classNameControl="col-xs-12 col-sm-9"
                    classNameLabel="col-xs-12 col-sm-3"
                    url={`/courseactions/find.json?key=id`}
                    placeholder={__("courseactions_single")}
                    onChange={this.onCourseActionChanged}
                />
                <Select
                    key="ct"
                    name="users"
					value={this.state.user}
                    label={__("attrs_users_groups")}
                    className="row form-group"
                    classNameControl="col-xs-12 col-sm-9"
                    classNameLabel="col-xs-12 col-sm-3"
                    placeholder={__("attrs_users_groups")}
                    url={this.state.usersUrl}
                    onChange={this.onUsersChanged}
                />
				<div className="row">
					<div className="col-xs-12">
						<div className="btn-group pull-right">
						
							<button className="btn btn-default green" disabled={this.state.isAddButtonDisable} onClick={this.saveShareOption}>
								<em className="la la-plus" />
							</button>
							<button className="btn btn-default danger" disabled={!this.state.can_delete} onClick={this.deleteSharedOption}>
								<em className="la la-trash" />
							</button>
						</div>
						<div className="clearfix"></div>
						<div className="widget-box">
							<div className="widget-body">
								<Table
									url={`${this.state.url}`}
									className="table alternate fixed"
									formatActions={this.formatStatus}
									onDataFetched={this.onDataFetched}
									columnFilters={this.columnFilters}
									emptyMessage="Ficheiros sem partilhas"
								/>
							</div>
						</div>
					</div>
				</div>
				<br />
            </div>
        );
    }
}
